import TopMenu from "@/components/TopMenu";
import { ScrollView } from "devextreme-react";
import { isMobile } from "../../helper/helper";
import { Outlet } from "react-router";
import SideHouseholdMenu from "./StockMenu";
import { Link } from "react-router-dom";
import withAuth from "@/hoc/withAuth";
import { useAppSelector } from "@/hooks/useAppSelector";
import AppVersion from "@/components/AppVersion";
import { IS_PRODUCTION } from "@/constants/constants";

function StockLayout() {
  const { code, id } = useAppSelector((state) => state.stock.editStockData);

  return (
    <div>
      <TopMenu inContext />
      {!IS_PRODUCTION ? <AppVersion /> : null}
      <div className="website-wrapper">
        <SideHouseholdMenu />
        <main className={`main_container print:w-[calc(100vw-4px)] print:max-w-[calc(100vw-4px)]`}>
          <div className="flex items-center gap-12 bg-white px-8 py-3 print:hidden">
            <Link to={`/stock`} className="flex h-11 w-max items-center gap-2">
              <img src="/icons/left-chevron-icon.svg" alt="" />
              <span className="text-sm">Exit</span>
            </Link>
            {code ? (
              <span className="text-neutral-300">
                <Link to="/stock" className="hover:text-neutral-200">
                  Stock
                </Link>{" "}
                /{" "}
                <Link className="hover:text-neutral-200" to={`/stock/${id}/browse`}>
                  {code} Details
                </Link>
              </span>
            ) : null}
          </div>
          <ScrollView
            height={isMobile.any() ? "calc(100vh - 11.875rem)" : "calc(100vh - 85px)"}
          >
            <div className="screen:px-8 screen:pb-8">
              <Outlet />
            </div>
          </ScrollView>
        </main>
      </div>
    </div>
  );
}

export default withAuth(StockLayout);
